import React, { useEffect, useState } from 'react';

import { SupportMessage } from '../../../../../types/entity.types';

import { ARCHIVED } from '../../../../../utils/constants';
import { formatUsername } from '../../../../../utils/util';

import ProgrammeLayout from '../../../../../layouts/programme/ProgrammeLayout';
import SupportChatBox from '../support-chat-box/SupportChatBox';
import SupportChatFilter from '../support-chat-filter/SupportChatFilter';
import SupportChatInput from '../support-chat-input/SupportChatInput';

import { ReactComponent as ArrowIcon } from '../../../../../resources/icons/arrow-single.svg';

import './support-chat.scss';

type Props = {
  status: string;
  messageOwner?: string;
  messages: SupportMessage[];
  createMessage: (messageOwner: string, callback: () => void) => void;
  navigateBack: () => void;
};

const SupportChat = ({ status, messageOwner = '', messages, createMessage, navigateBack }: Props) => {
  const [filterValue, setFilterValue] = useState<string>('');
  const [filteredMessages, setFilteredMessages] = useState<SupportMessage[]>([]);

  useEffect(() => {
    if (messages) {
      setFilteredMessages(
        messages.filter((message) => message.message.toLowerCase().includes(filterValue.toLowerCase()))
      );
    }
  }, [filterValue, messages]);

  return (
    <ProgrammeLayout>
      <div className="support-chat" data-testid={`support-chat-${status}`}>
        <div className="support-chat__header">
          <div className="support-chat__header__icon-container">
            <ArrowIcon onClick={navigateBack} data-testid="arrow-icon" />
          </div>
          <h1>{formatUsername(messageOwner)}</h1>
        </div>
        <SupportChatFilter value={filterValue} onChange={({ target }) => setFilterValue(target.value)} />
        <SupportChatBox messages={filteredMessages} />
        <SupportChatInput disabled={status === ARCHIVED} createMessage={createMessage} />
      </div>
    </ProgrammeLayout>
  );
};

export default SupportChat;
